import { useState } from "react";
import { ChevronDown, ChevronRight, Calculator, Gauge, Ruler } from "lucide-react";

const MESogDraft = () => {
  const [openSections, setOpenSections] = useState(false);

  const toggleSection = () => {
    setOpenSections((prev) => !prev);
  };

  const calculations = [
    {
      id: "mean-draft-calculation",
      title: "Mean Draft Calculation",
      description: "Average of all three draft measurements to determine vessel trim",
      formula: "Mean Draft = (Forward Draft + Mid Draft + Aft Draft) ÷ 3",
      borderColor: "border-blue-200",
      bgColor: "bg-blue-50",
      textColor: "text-blue-700",
    }
  ];

  const dataFields = [
    {
      name: "Speed Over Ground (SOG)",
      unit: "knots",
      description: "Vessel's actual speed relative to the seabed",
    },
    {
      name: "Forward Draft",
      unit: "meters",
      description: "Depth of vessel immersion at the bow",
    },
    {
      name: "Mid Draft",
      unit: "meters",
      description: "Depth of vessel immersion at the midship",
    },
    {
      name: "Aft Draft",
      unit: "meters",
      description: "Depth of vessel immersion at the stern",
    },
    {
      name: "Vessel State Transition",
      unit: "text",
      description: "Operational mode of the vessel",
    }
  ];

  return (
    <div>
      <div className="mb-6 border border-gray-300 rounded-lg overflow-hidden">
        <button
          className="flex items-center justify-between w-full p-5 bg-gray-50 hover:bg-gray-100 transition-colors"
          onClick={toggleSection}
        >
          <div className="flex items-center gap-4">
            <div className="p-3 bg-[#b6faed] rounded-lg">
              <Ruler className="w-6 h-6 text-[#117864]" />
            </div>
            <div className="text-left">
              <h2 className="text-md font-bold text-gray-800">
                Speed & Draft Calculations
              </h2>
              <p className="text-gray-600 text-sm">
                Formulas and measurement methodologies
              </p>
            </div>
          </div>
          {openSections ? (
            <ChevronDown className="w-5 h-5 text-gray-500" />
          ) : (
            <ChevronRight className="w-5 h-5 text-gray-500" />
          )}
        </button>

        {openSections && (
          <div className="p-5 bg-white border-t border-gray-200">
            {/* Measurement Fields */}
            <div className="mb-6">
              <h4 className="font-semibold text-gray-800 mb-3 flex items-center gap-2">
                <Gauge className="w-4 h-4" />
                Measurement Fields & Units
              </h4>
              <div className="grid grid-cols-3 gap-4">
                {dataFields.map((field, index) => (
                  <div key={index} className="p-4 border border-gray-200 rounded-lg bg-white">
                    <div className="flex justify-between items-start mb-2">
                      <h5 className="font-medium text-gray-800">{field.name}</h5>
                      <span className="text-xs bg-blue-100 text-blue-700 px-2 py-1 rounded">
                        {field.unit}
                      </span>
                    </div>
                    <p className="text-sm text-gray-600 mb-2">{field.description}</p>
                  </div>
                ))}
              </div>
            </div>

            <div className="mb-6">
              <h4 className="font-semibold text-gray-800 mb-3 flex items-center gap-2">
                <Calculator className="w-4 h-4" />
                Calculations & Formulas
              </h4>
              <div className="grid grid-cols-1 gap-4">
                {calculations.map((calc) => (
                  <div
                    key={calc.id}
                    className={`p-4 rounded-lg border ${calc.borderColor} ${calc.bgColor}`}
                  >
                    <h4 className="font-semibold text-gray-800 mb-2">
                      {calc.title}
                    </h4>

                    <div className="grid grid-cols-1 gap-4">
                      <div className="space-y-2">
                        <div>
                          <p className="text-sm font-medium text-gray-700">Description:</p>
                          <p className="text-sm text-gray-600">{calc.description}</p>
                        </div>
                        <div>
                          <p className="text-sm font-medium text-gray-700">Formula:</p>
                          <p className="text-sm font-semibold bg-white p-2 rounded border">
                            {calc.formula}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default MESogDraft;